import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { Form as FormikContainer, Formik } from 'formik'
import { useParams } from 'react-router-dom'
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material'
import { ResultadoApi, ResultadoApiBuscaParametro } from '../types'
import '../styles.scss'
import { SectionBoxData } from '../../../../../components/Section'
import List, { ListSection, ListRow, ListColumn } from '../../../../../components/List'
import { getApi, postApi } from '../../../../../utils/requestApi'
import { RequestResponsePattern } from '../../../../../types/Request'
import { useAppSelector } from '../../../../../store/hooks'
import { DOMAIN } from '../../../../../var_env.'

const TabParametro: React.FC = () => {

    const { idRamo } = useParams<any>()

    const [resultadoApi, setResultadoApi] = useState<ResultadoApi>()
    const [resultadoApiBusca, setresultadoApiBusca] = useState<null | ResultadoApiBuscaParametro>(null)
    const [listaIds, setListaIds] = useState<number[]>([])
    const [sendMessage, setSendMessage] = useState<string | null>(null)
    const [loadingSend, setLoadingSend] = useState<boolean>(false)

    const { userData } = useAppSelector(state => state.auth)

    useEffect(() => {
        (async () => {
            const response = await getApi({
                endpoint: `${DOMAIN}/`,
                params: `ramoAtividadeParametro?idRamoAtividade=${idRamo}`
            })
            setResultadoApi(response)

            const parametros = await getApi({
                endpoint: `${DOMAIN}/`,
                params: 'parametro'
            })
            setresultadoApiBusca(parametros)
        })()
    }, [idRamo])

    // popula listaIds corretamente quando vem da API
    useEffect(() => {
        if (resultadoApi?.listaResultados) {
            const ids = resultadoApi.listaResultados.map(x => x.idParametro)
            setListaIds(ids)
        }
    }, [resultadoApi])

    const handleEditarCheck = useCallback(
        (e: ChangeEvent<HTMLInputElement>, idParametro: number) => {
            if (e.target.checked) {
                setListaIds(prev => [...prev, idParametro])
            } else {
                setListaIds(prev => prev.filter(id => id !== idParametro))
            }
        },
        []
    )

    const handleSalvar = useCallback(async () => {

        setLoadingSend(true)

        const newLista = listaIds.filter((elem, index, self) => index === self.indexOf(elem))

        const listaResultadoDados = newLista.map(id => ({
            idParametro: id
        }))

        const dados = {
            idRamoAtividade: idRamo,
            idUsuario: userData?.id,
            listaParametros: listaResultadoDados
        }

        const response: RequestResponsePattern<any> = await postApi({
            endpoint: `${DOMAIN}/ramoAtividadeParametro`,
            data: dados
        })

        if (response) setSendMessage('Salvo com sucesso')
        else setSendMessage(`Erro ${(response as any).listaMensagens?.[0]}`)

        setLoadingSend(false)

    }, [listaIds, idRamo, userData])

    return (
        <>
            <SectionBoxData title="Parâmetros">
                <Formik initialValues={{}} onSubmit={handleSalvar}>
                    <FormikContainer>
                        <FormGroup>
                            <List name="parametros">
                                <ListSection>
                                    {resultadoApiBusca?.listaResultados.map((ListaParametros, index) => (
                                        <ListRow key={index} grid={`1fr`} zebra={index % 2 === 0}>
                                            <ListColumn>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={listaIds.includes(ListaParametros.id)}
                                                            onChange={(e) => handleEditarCheck(e, ListaParametros.id)}
                                                        />
                                                    }
                                                    label={ListaParametros.descricao}
                                                />
                                            </ListColumn>
                                        </ListRow>
                                    ))}
                                </ListSection>
                            </List>
                        </FormGroup>

                        {sendMessage && (
                            <div id="message">
                                <span className={`status ${sendMessage.includes('Erro') ? 'error' : 'success'}`}>
                                    {sendMessage}
                                </span>
                            </div>
                        )}

                        <div id="control">
                            <button
                                type="submit"
                                className={`default ${loadingSend ? 'status disabled' : ''}`}
                            >
                                {loadingSend && <div className="spinner" />}
                                Salvar
                            </button>
                        </div>
                    </FormikContainer>
                </Formik>
            </SectionBoxData>
        </>
    )
}

export default TabParametro